import { selectClasses } from '@mui/material';
import { colorPalette } from '../../colorPalette';
export const filterDatePaperStyle = {
    boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.12)',
    borderRadius: '8px',
};
export const selectDateFilterStyle = {
    '& > div': {
        height: 'auto',
        padding: '20px 32px 8px 16px !important',
    },
    /** To expand the clickable part above the arrow icon on the right */
    [`& .${selectClasses.select}`]: {
        marginRight: '-32px',
    },
};
export const selectDatesFilterWrapperStyle = {
    position: 'relative',
    marginBottom: '8px',
};
export const selectDatesSelectorLabelstyle = {
    top: '3px',
    position: 'absolute',
};
export const dateRowStyle = {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
};
export const clearIconStyle = {
    position: 'absolute',
    bottom: '14px',
    right: '8px',
    color: colorPalette.gray500,
    fontSize: '16px',
    cursor: 'pointer',
};
export const dateArrowIconStyle = {
    marginRight: '8px',
    color: colorPalette.gray300,
    fontSize: '16px',
};
export const dateCalendarIconStyle = {
    '& button': {
        color: colorPalette.gray500,
    },
};
